import React, {Component} from 'react';
import Options from '../Entity/Options';
import Config from '../../../Configs';
import ConverConfigsTemplates from '../Entity/Convert/Configs';
import TextEditor from '../../../components/UI/Editors/Text';
import GridLayout from 'react-grid-layout';

import './DashboardImport.css';

let pivots = {};

class DashboardImport extends Component {

    state = {
        openPopup: false,
        tables: [],
        zoom: 10
    }

    componentDidMount() {
        this.fetchPivotTable();
    }

    componentWillUnmount() {
		console.log("componentWillUnmount");
		pivots = {}
	}

    fetchPivotTable = () => {
        const tables = [...this.props.tables];
        const type = this.props.type;
        const file = this.props.file;
        for(let i = 0; i < tables.length; i++) {
            const table = tables[i];
            if(table.isDashboard != true) {
                continue;
            }
            if(
                table.configuation == undefined || 
                !table.configuation
            ) {
                continue;
            }
            const options = table.configuation;
            const configuation = ConverConfigsTemplates.convertToAfterProgress(options);
            if(
                configuation.slice == undefined || 
                !configuation.slice
            ) {
                continue;
            }
            const flexIdContainer = `dashboard-import-${type}-${i}`;
            const reports = {
                ...{
                    dataSource: {
                        type: "csv",
                        filename: `${file}`,
                    },
                },
                ...{
                    slice: configuation.slice || {}
                },
                ...{
                    options: {
                        ...configuation.options || {},
                        ...{
                            "configuratorButton": false,
                            "drillThrough": false,
                        }
                    },
                },
                ...{
                    formats: configuation.formats || []
                },
                ...{
                    conditions: configuation.conditions || []
                }
                
            }
            if(pivots[flexIdContainer] == undefined || !pivots[flexIdContainer]) {
                pivots[flexIdContainer] = {};
                pivots[flexIdContainer] = new window.Flexmonster({
                    container: flexIdContainer,
                    global: {
                        options: {
                            "defaultDateType": "string",
                        },
                        localization: {
                            grid: {
                                blankMember: " "
                            }
                        }
                    },
                    height: "100%",
                    width: "100%",
                    report: reports,
                    licenseKey: Config.licensePivot
                })
            }
            else {
                const pivot = pivots[flexIdContainer];
                const oldConfigs = pivot.getReport();
    
                //Set Options to default params
                pivot.setOptions(Options);
                pivot.removeSelection();
                pivot.removeAllConditions();
                pivot.refresh();
    
                if(
                    oldConfigs !== undefined &&
                    oldConfigs &&
                    oldConfigs.slice !== undefined && 
                    oldConfigs.slice && 
                    oldConfigs.slice.reportFilters !== undefined &&
                    oldConfigs.slice.reportFilters
                ) {
                    const filters = [...oldConfigs.slice.reportFilters];
                    for(let i = 0; i < filters.length; i++) {
                        const filter = filters[i];
                        if(filter.uniqueName == undefined) {
                            continue;
                        }
                        pivot.clearFilter(filter.uniqueName);
                    }
                }
    
                if(configuation.slice !== undefined) {
                    pivot.runQuery(configuation.slice);
                }
                if(configuation.options !== undefined) {
                    pivot.setOptions(configuation.options);
                    pivot.refresh();
                }
                if(configuation.formats !== undefined) {
                    const formats = [...configuation.formats];
                    for(let i = 0; i < formats.length; i++) {
                        pivot.setFormat(formats[i]);
                        pivot.refresh();
                    }
                }
                if(configuation.conditions !== undefined) {
                    const conditions = [...configuation.conditions];
                    for(let i = 0; i < conditions.length; i++) {
                        pivot.addCondition(conditions[i]);
                        pivot.refresh();
                    }
                }
            }
        }
    }

    zoomInHandler = () => {
		const zoom = this.state.zoom;
		this.setState({
			zoom: zoom + 1 >= 10 ? 10 : zoom + 1
		})
	}

	zoomOutHandler = () => {
		const zoom = this.state.zoom;
		this.setState({
			zoom: zoom - 1 <= 0 ? 1 : zoom - 1
		})
	}
   
    render() {
        const tables = [...this.props.tables];
        const editors = [...this.props.editors];
        const type = this.props.type;
        const tablesWithIndex = tables.map((table, index) => {
            return {
                ...table,
                id: index
            }
        });
        const chartTables = tablesWithIndex.filter(table => {
            if(table.isDashboard === true) {
                return true;
            }	
            return false;
        });
        const zoom = this.state.zoom;
        const actionCharts = (
            <div className="col-md-12 col-lg-12 col-xs-12">
                <div className="btn-group viewType pull-left">
                    <button className="btn btn-default" onClick={this.zoomOutHandler}><i className="fa fa-search-minus"></i></button>
                    <button className="btn btn-default">{zoom ? (zoom * 10) + "%" : "100%"}</button>
                    <button className="btn btn-default" onClick={this.zoomInHandler}><i className="fa fa-search-plus"></i></button>
                </div>
            </div>
        )
        return (
            <React.Fragment>
                <div className="DashboardImport">
                    <div className="row">
                        {actionCharts}
                    </div>
                    <div className="row">
                        <GridLayout className={`layout zoom${zoom}`} cols={12} rowHeight={30} width={2000} height={1000}
                            isDraggable={false}
                            isResizable={false}
                            // draggableHandle={".Dragable"}
                            // breakpoints={{lg: 1200, md: 1200, sm: 1200, xs: 1200, xxs: 1200}}
                            // cols={{lg: 12, md: 12, sm: 12, xs: 12, xxs: 12}}
                            // onDragStop={(item) => this.updatePositionChart(item)}
                            // onResizeStop={(item) => this.updatePositionChart(item)}
                        >
                            {
                                chartTables.map((table, key) => {
                                    const containerId = `dashboard-import-${type}-${table.id}`;
                                    if(table.dashboard == undefined) {
                                        table.dashboard = {};
                                    }
                                    if(table.dashboard.grid == undefined) {
                                        table.dashboard = {
                                            ...table.dashboard,
                                            grid: {
                                                x: 0, 
                                                y: Infinity, 
                                                w: 2, 
                                                h: 10
                                            }
                                        };
                                    }
                                    return (
                                        <div className="Resizable" key={table.id} data-grid={{...table.dashboard.grid}}>
                                            <div className="box">
                                                <div className="box-header with-border">
                                                    <h3 className="box-title">{table.name}</h3>
                                                </div>
                                                <div className="box-body">
                                                    <div id={containerId} className="item_dashboard">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                editors.map((editor, key) => {
                                    let grid = {
                                        x: 0, 
                                        y: Infinity, 
                                        w: 4, 
                                        h: 2
                                    };
                                    if(editor.grid !== undefined) {
                                        grid = {
                                            ...editor.grid
                                        }
                                    }
                                    
                                    return (
                                        <div className="Resizable Editor" key={`text_` + key} data-grid={{...grid,minW:2,minH:2,maxH:2}}>
                                            <div className="box">
                                                <div className="box-body">
                                                    <TextEditor name={editor.name} disabled={true}></TextEditor>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </GridLayout>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default DashboardImport;